import styled from 'styled-components';

export const NewProductSection = styled.div`
  background-color: ${(props) => (props.stretchMarksPage ? '#fff' : props.sectionBgColor || '#e2ffea')};
  padding-top: ${(props) => (props.stretchMarksPage ? '0px' : '40px')};
  .headerImage {
    width: 100%;
  }
  .heading {
    font-size: 24px;
    font-weight: 600;
    text-align: center;
    color: rgba(0, 0, 0, 0.87);
    padding-top: 18px;
  }
  .productContainer {
    padding-top: 18px;
    overflow: scroll;
    width: 70%;
    display: flex;
    -webkit-box-pack: start;
    justify-content: flex-start;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    &::-webkit-scrollbar {
      display: none;
    }
    @media (max-width: 720px) {
      width: 100%;
      padding: 18px 8px 8px;
      gap: 4px;
    }
    .variantType {
      margin-top: 10px;
      padding: 3px 8px;
      border-radius: 7px;
      background-color: #ebebeb;
      width: max-content;
      p {
        font-size: clamp(9px, 2vw, 14px);
        color: rgba(0, 0, 0, 0.6);
        font-weight: 500;
      }
    }
    .productNameNew {
      font-size: clamp(13px, 2vw, 18px);
      font-weight: 600;
      color: rgba(0, 0, 0, 0.87);
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }
`;
